var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": _vm.value !== null,
        label: "現在の就業状況",
        half: "",
      },
    },
    _vm._l(_vm.options, function (option, i) {
      return _c(
        "label",
        { key: i, staticClass: "pega-badge-radio pega-mr-5" },
        [
          _c("input", {
            attrs: { "data-test": "option-" + option.id, type: "radio" },
            domProps: { checked: _vm.value === option.id, value: option.id },
            on: {
              change: function ($event) {
                return _vm.$emit("input", $event.target._value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "pega-badge-radio-text pega-badge-radio-check-mark",
              attrs: { "data-test": "option-name-" + option.id },
            },
            [_vm._v(_vm._s(option.name))]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }